export default "__VITE_ASSET__Q4Y7_$$J__"